export default __webpack_public_path__ + "static/media/1869.550827ba.png";